import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingRoutingModule } from './setting-routing.module';


@NgModule({
  declarations: [],
  imports: [    
    CommonModule,
    SettingRoutingModule
  ]
})
export class SettingModule { }
